import React from 'react';
import { Outlet } from 'react-router-dom';
import '../../assets/css/common.css';
import Header from './Header';
import Sidebar from './Sidebar';

const GlucodataLayout = () => {
  const glucodataItems = [
      { to: '/glucodata', label: '혈당 수치 조회' },
    ];

  return (
    <div className="wrap">
      <Header />
      <div className="section_area">
        <Sidebar items={glucodataItems}/>
        <div className="section_wrap">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default GlucodataLayout;
